/**
 * @owner @Appboy/messaging-experience
 */

import { customEventRemoteLookupValidators } from "@schemas/remoteLookup/customEventRemoteLookupSchema";
import type {
  CustomEventRemoteLookupId,
  CustomEventRemoteLookupItem,
  CustomEventRemoteLookupFilters,
} from "@schemas/types";

import type { RemoteLookupProvider } from "./types";

export const customEventProvider: RemoteLookupProvider<
  CustomEventRemoteLookupId,
  CustomEventRemoteLookupItem,
  CustomEventRemoteLookupFilters
> = {
  mapItemToId: (item) => item.indexed_name,
  mapIdToString: (id) => id,
  mapItemToSearchString: (item) => item.name,
  validators: customEventRemoteLookupValidators,
};
